import { TrackingUtils } from "./../trackings.utils";
import { __ } from "@wordpress/i18n";
import { envConfig } from "./../config/envconfig";
// TODO WP backbone client, da approfondire
// ? https://developer.wordpress.org/rest-api/using-the-rest-api/backbone-javascript-client/
// window.wp.api.loadPromise.done(function () {
//   var post = new window.wp.api.PostMeta...
// });

import Validators from "../validators";
import ProductApi from "./product-api";
import ProductRenderers from "./product.renderers";
import {
  AssistenzaPratichePayload,
  AvailableProductResponse,
  MacrocategoriaProdotto,
  ProductPriceResponse,
  SupportPayload,
} from "./product.models";
import { renderTooltip } from "../../assets/main";
import RecaptchaHelper from "../recaptcha";
import Utils from "../utils";
import { InfoUtente, LoginLocalStorageData } from "../header.models";
declare global {
  interface Window {
    wp: any;
    php_pars: any;
    uhconfig: any;
  }
}

class CoverageCheck {
  cap: string;
  supplyID: string | undefined;
  nosupplyID: string | undefined;
  supplyCatalogueID: string | undefined;
  nosupplyCatalogueID: string | undefined;
  supplyMacrocategoria: MacrocategoriaProdotto | undefined;
  nosupplyMacrocategoria: MacrocategoriaProdotto | undefined;
  pageURL: string;
  window: Window & typeof globalThis;

  // Content Selectors
  mainContainer: HTMLDivElement | null;
  coverageFormContainer: HTMLDivElement | null;
  notAvailableContainer: HTMLDivElement | null;
  errorContainer: HTMLDivElement | null;
  resumeContainer: HTMLDivElement | null;
  capInputElement: HTMLInputElement | null;
  //comuneInputElement: HTMLInputElement | null;
  sendButton: HTMLButtonElement | null;
  resetButton: HTMLButtonElement | null;
  buyWithSupply: HTMLAnchorElement | null;
  buyButtonWithout: HTMLAnchorElement | null;
  supportButton: HTMLButtonElement | null;
  spinner: HTMLDivElement | null;
  radioButtons: NodeListOf<HTMLInputElement> | null;
  pInfo: SupportPayload | undefined;
  private readonly trackings: TrackingUtils;

  constructor() {
    this.cap = "";
    this.supplyID = undefined;
    this.nosupplyID = undefined;
    this.trackings = new TrackingUtils();
  }

  /**
   * Inizializza classe Coverage con gli eventlistener sul form
   */
  init() {
    this.mainContainer = document.querySelector("#product-coverage-box");
    if (this.mainContainer) {
      this.coverageFormContainer = document.querySelector(
        "#product-coverage-container"
      );
      this.resumeContainer = document.querySelector(
        "#product-resume-container"
      );
      this.notAvailableContainer = document.querySelector(
        "#product-notavailable-container"
      );
      this.errorContainer = document.querySelector("#product-error-container");
      this.supplyID = this.mainContainer.dataset.mainid;
      this.nosupplyID = this.mainContainer.dataset.variantid;
      this.supplyCatalogueID = this.mainContainer.dataset.maincatalogueid;
      this.nosupplyCatalogueID = this.mainContainer.dataset.variantcatalogueid;
      this.supplyMacrocategoria = this.mainContainer.dataset
        .macrocategoriamain as MacrocategoriaProdotto;
      this.nosupplyMacrocategoria = this.mainContainer.dataset
        .macrocategoriavariant as MacrocategoriaProdotto;
      this.pageURL = window.location.href;

      if (!this.supplyID && !this.nosupplyID) {
        this.renderProductNotConfigured();
        return;
      }
      const searchParams = new URLSearchParams(window.location.search);
      const pInfoB64 = searchParams.get("pinfo");
      if (pInfoB64) {
        console.log("test", Utils.decodeB64(pInfoB64));
        this.pInfo = JSON.parse(Utils.decodeB64(pInfoB64)) as SupportPayload;
        this.cap = this.pInfo?.cap;
        searchParams.set("cap", this.cap);
        var newRelativePathQuery =
          window.location.pathname +
          "?" +
          searchParams.toString() +
          window.location.hash;
        history.replaceState(null, "", newRelativePathQuery);
      }
      const params: URLSearchParams = new URL(this.pageURL).searchParams;
      const queryCAP: string = params.get("cap");
      if (queryCAP || this.cap) {
        if (!this.cap) this.cap = queryCAP;

        this.prepareFirstStep().then(async () => {
          await this.handleQueryStringCAP();
          // await this.trackings.trackPreShowPrice(this.nosupplyMacrocategoria ?? this.supplyMacrocategoria, this.nosupplyID ?? this.supplyID);
        });
      } else {
        this.prepareFirstStep().then(async (_) => {
          await this.trackings.trackPreShowPrice(
            this.nosupplyMacrocategoria ?? this.supplyMacrocategoria,
            this.nosupplyID ?? this.supplyID
          );
        });
      }

      document.addEventListener("scroll", this.showStickyItems);
    }
  }

  private showStickyItems = () => {
    const boundingRect = this.mainContainer.getBoundingClientRect();
    const allowance = this.mainContainer.offsetHeight / 3;

    if (boundingRect.bottom < allowance) {
      document.querySelector("#product-sticky-area").classList.add("visible");
    } else {
      document
        .querySelector("#product-sticky-area")
        .classList.remove("visible");
    }
  };

  /**
   * Gestisce la visibilità del primo step di inserimento manuale del CAP
   * renderizza la parte HTML e appende gli handlers
   */
  private prepareFirstStep() {
    return new Promise<void>((resolve) => {
      ProductRenderers.renderCoverageForm(this.coverageFormContainer).then(
        () => {
          this.capInputElement = document.querySelector("#capInput");
          //this.comuneInputElement = document.querySelector("#comuneInput");
          this.sendButton = document.querySelector("#sendCapButton");
          this.spinner = document.querySelector("#content-loader");
          this.resumeContainer.style.display = "none";
          this.notAvailableContainer.style.display = "none";
          this.errorContainer.style.display = "none";
          this.coverageFormContainer.style.display = "block";

          ProductRenderers.shouldShow("#sticky-coveragecheck", true);
          ProductRenderers.shouldShow("#sticky-product-buy", false);

          this.addEventHandlers();
          //primo tracking messo come evento load perchè spesso risulta undefined
        }
      );
      return resolve();
    });
  }

  /**
   * Gestisce visibiltà dello step corretto a seconda della disponibilità del servizio per il cap inviato
   * @param data
   */
  private prepareFinalStep(
    withSupply: AvailableProductResponse,
    withoutSupply: AvailableProductResponse
  ) {
    // this.trackings.trackCalcolaPrezzo();
    console.info("Checking pricing...");
    this.coverageFormContainer.style.display = "none";
    const variants = [withSupply, withoutSupply].filter((res) => res?.coperto);
    if (!variants || variants?.length == 0) {
      //se non ci sono variants, gestisco il processo come non disponibile, ma avviso via console
      console.warn("No variants configured");
      this.handleUnavailableCoverage(
        this.nosupplyID ?? this.supplyID,
        this.nosupplyCatalogueID ?? this.supplyCatalogueID
      );
      return;
    }
    console.log("VARIANTS", variants);
    const priceCalls: Promise<ProductPriceResponse>[] = [];
    //voglio renderizzare solo i prezzi sui prodotti effettivamente configurati e coperti
    //promise a null se non ho un prezzo con fornitura
    withSupply
      ? priceCalls.push(
          ProductApi.getProductPrice(
            withSupply.cap,
            withSupply.id,
            this.supplyCatalogueID //visto che me lo passo da contribuzione e spesso risulta null da api
          )
        )
      : priceCalls.push(new Promise((resolve) => resolve(null)));
    //promise a null se non ho un prezzo senza fornitura
    withoutSupply
      ? priceCalls.push(
          ProductApi.getProductPrice(
            withoutSupply.cap,
            withoutSupply.id,
            this.nosupplyCatalogueID //visto che me lo passo da contribuzione e spesso risulta null da api
          )
        )
      : priceCalls.push(new Promise((resolve) => resolve(null)));
    Promise.all(priceCalls)
      .then((pricings) => {
        if (this.spinner) {
          this.spinner.style.display = "none";
        }
        if (!pricings || pricings?.filter((pr) => !!pr).length == 0) {
          console.warn("Nessun prezzo tornato da api");
          this.handleError();
          return;
        }
        console.log("pricings!", pricings);

        //MOCK
        //pricings[0] = { ...pricings[1] };
        //pricings[0].prezzoTotale = 250;

        //controlla il prezzo solo se entrambi (con o senza fornitura) non sono di tipo installazione
        if (
          this.supplyMacrocategoria != "installazione" &&
          this.nosupplyMacrocategoria != "installazione"
        ) {
          //prodotto non disponibile se il prezzo è 0 (caso singolo) o entrambi 0 (caso con e senza fornitura)
          if (
            (pricings[0]?.prezzoTotale <= 0 ||
              pricings[0]?.prezzoTotale == null) &&
            (pricings[1]?.prezzoTotale <= 0 ||
              pricings[1]?.prezzoTotale == null)
          ) {
            this.handleUnavailableCoverage(
              this.nosupplyID ?? this.supplyID,
              this.nosupplyCatalogueID ?? this.supplyCatalogueID
            );
            return;
          }
        }

        ProductRenderers.renderResume(
          this.resumeContainer,
          {
            withSupply: pricings[0],
            withoutSupply: pricings[1],
            macrocategoriaWithSupply: this.supplyMacrocategoria,
            macrocategoriaWithoutSupply: this.nosupplyMacrocategoria,
          },
          this.cap
        ).then(() => {
          // default: senza fornitura
          if (pricings[1]) {
            if (this.supplyMacrocategoria != "installazione") {
              document.querySelector<HTMLSpanElement>(
                "#sticky-product-total"
              ).innerText =
                "€ " + Utils.floatToEuro(Number(pricings[1]?.prezzoTotale));
            } else {
              document.querySelector<HTMLSpanElement>(
                "#sticky-product-total"
              ).innerText = __("Da definire", "unipolhome");
            }
            document.querySelector<HTMLAnchorElement>(
              "#sticky-buy-button"
            ).href = pricings[1]
              ? new URL(pricings[1]?._links[0]?.href)?.toString()
              : "";
          } else if (pricings[0]) {
            if (this.nosupplyMacrocategoria != "installazione") {
              document.querySelector<HTMLSpanElement>(
                "#sticky-product-total"
              ).innerText =
                "€ " + Utils.floatToEuro(Number(pricings[0]?.prezzoTotale));
            } else {
              document.querySelector<HTMLSpanElement>(
                "#sticky-product-total"
              ).innerText = __("Da definire", "unipolhome");
            }
            document.querySelector<HTMLAnchorElement>(
              "#sticky-buy-button"
            ).href = pricings[0]
              ? new URL(pricings[0]?._links[0]?.href)?.toString()
              : "";
          }
          ProductRenderers.emptyContainer(this.notAvailableContainer);
          ProductRenderers.emptyContainer(this.errorContainer);
          this.resumeContainer.style.display = "block";
          this.addBuyButtonHandlers(pricings[0], pricings[1]);
          this.addResetButtonHandler();
          this.addCoverageRadioHandler(pricings);

          ProductRenderers.shouldShow("#sticky-coveragecheck", false);
          ProductRenderers.shouldShow("#sticky-product-buy", true);

          this.addGotoButtonHandler();
        });
        renderTooltip();
        if (pricings.filter((p) => !!p).length == 1) {
          this.trackings.trackPostShowPrice(
            this.nosupplyMacrocategoria ?? this.supplyMacrocategoria,
            this.nosupplyID ?? this.supplyID,
            this.cap
          );
        } else {
          this.trackings.trackPostShowPriceFornitura(
            this.nosupplyMacrocategoria,
            this.nosupplyID,
            this.cap
          );
        }
      })
      .catch((e) => {
        console.error(e);
        console.error("Errore servizi");
        this.handleError();
        Utils.toggleSubmitButtonStatus(this.sendButton, "enabled");
      });
  }
  /**
   * Gestione caso variant non coperta / nessuna variant configurata
   */
  private handleUnavailableCoverage(
    idProdotto: string = "",
    codCatalogo: string = ""
  ) {
    if (this.spinner) {
      this.spinner.style.display = "none";
    }
    ProductRenderers.renderUnavailableContainer(
      this.notAvailableContainer,
      idProdotto ?? "",
      this.cap
    ).then(() => {
      document
        .querySelector("#product-coverage-box")
        .classList.remove("invisible");
      this.trackings.trackProductUnavailableCoverage(
        this.nosupplyMacrocategoria ?? this.supplyMacrocategoria,
        this.nosupplyID ?? this.supplyID,
        this.cap
      );
      ProductRenderers.emptyContainer(this.resumeContainer);
      this.notAvailableContainer.style.display = "block";
      this.addResetButtonHandler();
      const inputEl =
        this.notAvailableContainer.querySelector<HTMLInputElement>(
          "#emailInput"
        );
      const infoUtente = (<LoginLocalStorageData>(
        JSON.parse(localStorage.getItem("info_utente_reducer"))
      ))?.info_utente;
      const postPayload: AssistenzaPratichePayload = {
        idTriplettaInterazione: php_pars.idtripletta.nocoverage,
        domandaAssistenza: `Mancata copertura per cap: ${this.cap}`,
        mezzoRicontatto: "email",
      };
      if (infoUtente?.recupera_info_utente?.result) {
        postPayload.datiAnagrafica = {
          nome: infoUtente.recupera_info_utente.result.nome ?? "anonimo",
          cognome: infoUtente.recupera_info_utente.result.cognome ?? "anonimo",
          email: "",
          numeroTelefono: infoUtente.recupera_info_utente.result.numeroTelefono,
        };
      }
      if (this.pInfo || infoUtente?.recupera_info_utente?.result?.email) {
        inputEl.value =
          this.pInfo?.email ?? infoUtente?.recupera_info_utente?.result?.email;
      }
      const privacyTextEl = this.notAvailableContainer.querySelector(
        "#zipcode-privacy-html"
      );
      privacyTextEl.innerHTML = php_pars.privacy_text_html?.replace(
        /'/g,
        "&apos;"
      );

      //
      this.addSupportButtonHandler(
        postPayload,
        php_pars.idtripletta.nocoverage,
        `${envConfig.SUPPORTPATH}assistenza/contatti`
      );
    });
  }
  /**
   * Gestione caso di errore
   */
  private handleError() {
    if (this.spinner) {
      this.spinner.style.display = "none";
    }
    ProductRenderers.renderErrorContainer(this.errorContainer).then(() => {
      document
        .querySelector("#product-coverage-box")
        .classList.remove("invisible");
      ProductRenderers.emptyContainer(this.resumeContainer);
      this.coverageFormContainer.style.display = "none";
      this.errorContainer.style.display = "block";
    });
  }
  /**
   * Gestisce inizializzazione handlers su eventi bottoni e inputs
   */
  private addEventHandlers() {
    // Bottone di invio richiesta verifica copertura
    this.sendButton.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      this.handleCoverageButtonClick(this.cap, this.supplyID, this.nosupplyID);
    });

    // Verifica copertura su invio da campo cap
    this.capInputElement.addEventListener("keypress", (e: KeyboardEvent) => {
      if (e.code === "Enter") {
        e.preventDefault();
        this.handleCoverageButtonClick(
          this.cap,
          this.supplyID,
          this.nosupplyID
        );
      }
    });

    // Campo input del CAP
    this.capInputElement.addEventListener("keyup", (e: KeyboardEvent) => {
      //Check per non interrompere animazione di spinning sull'enter
      if (e.code !== "Enter") {
        const target = e.target as HTMLInputElement;
        this.cap = target.value.toString();

        if (Validators.validateCap(this.cap)) {
          Utils.enableSubmitButton(this.sendButton, true);
        } else {
          Utils.enableSubmitButton(this.sendButton, false);
        }
      }
    });

    /*
    this.capInputElement.addEventListener("keypress", (e: KeyboardEvent) => {
      if (e.code === "Enter") {
        e.preventDefault();
        this.handleCoverageButtonClick(
          this.cap,
          this.supplyID,
          this.nosupplyID
        );
      }
    });

    // Campo input del CAP
    this.capInputElement.addEventListener("keyup", (e: KeyboardEvent) => {
      //Check per non interrompere animazione di spinning sull'enter
      if (e.code !== "Enter") {
        const target = e.target as HTMLInputElement;
        this.cap = target.value.toString();

        if (Validators.validateCap(this.cap)) {
          Utils.enableSubmitButton(this.sendButton, true);
        } else {
          Utils.enableSubmitButton(this.sendButton, false);
        }
      }
    });

*/
    document
      .querySelector("#goto-coverage-form-button")
      .addEventListener("click", (e: MouseEvent) => {
        e.preventDefault();
        ProductRenderers.handleScrollToItem(this.mainContainer);
        const capInput = document.querySelector<HTMLInputElement>("#capInput");
        if (capInput) {
          capInput.focus();
        }
      });
  }

  private addResetButtonHandler() {
    this.resetButton = document.querySelector("#reset-button");
    this.resetButton.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      this.cap = undefined;
      if ("URLSearchParams" in window) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.delete("cap");
        var newRelativePathQuery =
          window.location.pathname +
          "?" +
          searchParams.toString() +
          window.location.hash;
        history.replaceState(null, "", newRelativePathQuery);
      }
      this.prepareFirstStep();
    });
  }
  private addSupportButtonHandler(
    payload: AssistenzaPratichePayload,
    idTripletta: number,
    fallBackBaseUrl: string = null
  ) {
    this.supportButton =
      document.querySelector<HTMLButtonElement>("#sendEmailButton");
    const inputEl =
      this.notAvailableContainer.querySelector<HTMLInputElement>("#emailInput");
    const privacyEl =
      this.notAvailableContainer.querySelector<HTMLInputElement>(
        "#product-privacy-input"
      );
    const noPrivacyErrorEl =
      this.notAvailableContainer.querySelector<HTMLSpanElement>(
        "#product-no-privacy"
      );
    const handler = (e: Event) => {
      e.preventDefault();
      noPrivacyErrorEl.classList.add("d-none");
      privacyEl.classList.remove("invalid");
      if (e.type == "keyup") {
        if ((e as KeyboardEvent).code !== "Enter") {
          return;
        }
      }
      const mailCheck = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!mailCheck.test(inputEl.value)) {
        console.error("Mail non valida");
        return;
      }
      if (!payload.datiAnagrafica) {
        payload.datiAnagrafica = { nome: "anonimo", cognome: "anonimo" };
      }
      payload.datiAnagrafica.email = inputEl.value;
      if (!privacyEl.checked) {
        noPrivacyErrorEl.classList.remove("d-none");
        privacyEl.classList.add("invalid");
        return;
      }
      ProductApi.postSupportData(payload).then((res) => {
        if (res) {
          const leadForm =
            this.notAvailableContainer.querySelector<HTMLDivElement>(
              "#lead-form"
            );
          const leadTitle =
            this.notAvailableContainer.querySelector<HTMLDivElement>(
              "#lead-title"
            );
          const resetButtonContainer =
            this.notAvailableContainer.querySelector<HTMLDivElement>(
              "#lead-button-container"
            );
          this.sendButton.classList.add("d-none");
          leadTitle.classList.add("d-none");
          resetButtonContainer.classList.add("d-none");
          resetButtonContainer.classList.add("invisible");
          ProductRenderers.renderProductLeadTakenMessage(leadForm);
        } else {
          console.error("Api error");
        }
      });
    };
    this.supportButton.addEventListener("click", handler);
    inputEl.addEventListener("keyup", handler);
  }

  private addBuyButtonHandlers(
    withSupply: ProductPriceResponse,
    withoutSupply: ProductPriceResponse
  ) {
    this.buyWithSupply =
      document.querySelector<HTMLAnchorElement>("#buyButton-main");
    this.buyButtonWithout =
      document.querySelector<HTMLAnchorElement>("#buyButton-variant");

    //const pInfoMain: string = this.generateProductBase64({ cap: withSupply.cap, idCatalogo: withSupply.codiceCatalogo, idProdotto: withSupply.id });
    //const pInfoVariant: string = this.generateProductBase64({ cap: withoutSupply.cap, idCatalogo: withoutSupply.codiceCatalogo, idProdotto: withoutSupply.id });

    if (this.buyWithSupply) {
      this.buyWithSupply.href = withSupply
        ? new URL(withSupply._links[0].href).toString()
        : "";

      // marketing campaign
      if (sessionStorage.getItem("cmp")) {
        let pInfoEncoded: string = new URLSearchParams(
          new URL(withSupply._links[0].href).search
        ).get("pinfo");
        let pInfoDecoded = JSON.parse(
          decodeURIComponent(escape(window.atob(pInfoEncoded)))
        );
        pInfoDecoded.cmp = sessionStorage.getItem("cmp");

        pInfoEncoded = window.btoa(
          unescape(encodeURIComponent(JSON.stringify(pInfoDecoded)))
        );

        let searchParams = new URLSearchParams(
          new URL(withSupply._links[0].href).search
        );
        searchParams.set("pinfo", pInfoEncoded);
        //searchParams.toString();
        let newUrl: URL = new URL(withSupply._links[0].href);
        newUrl.search = searchParams.toString();

        this.buyWithSupply.href = newUrl.href.toString();
      }

      this.buyWithSupply.addEventListener("click", () => {
        this.trackings.trackAcquista();
      });
    }
    if (this.buyButtonWithout) {
      this.buyButtonWithout.href = withoutSupply
        ? new URL(withoutSupply._links[0].href)?.toString()
        : "";

      if (sessionStorage.getItem("cmp")) {
        let pInfoEncoded: string = new URLSearchParams(
          new URL(withoutSupply._links[0].href).search
        ).get("pinfo");
        let pInfoDecoded = JSON.parse(
          decodeURIComponent(escape(window.atob(pInfoEncoded)))
        );
        pInfoDecoded.cmp = sessionStorage.getItem("cmp");

        pInfoEncoded = window.btoa(
          unescape(encodeURIComponent(JSON.stringify(pInfoDecoded)))
        );

        let searchParams = new URLSearchParams(
          new URL(withoutSupply._links[0].href).search
        );
        searchParams.set("pinfo", pInfoEncoded);
        //searchParams.toString();
        let newUrl: URL = new URL(withoutSupply._links[0].href);
        newUrl.search = searchParams.toString();

        this.buyButtonWithout.href = newUrl.href.toString();
      }
    }
    this.buyButtonWithout.addEventListener("click", () => {
      this.trackings.trackAcquista();
    });
  }

  private addGotoButtonHandler() {
    document
      .querySelector("#goto-bill-box")
      .addEventListener("click", (e: MouseEvent) => {
        e.preventDefault();
        ProductRenderers.handleScrollToItem(this.mainContainer);
      });
  }

  /**
   * Gestisce apertura e chiusura sezioni con e senza copertura
   */
  private addCoverageRadioHandler = (pricings: ProductPriceResponse[]) => {
    this.radioButtons = document.querySelectorAll('input[name="has-coverage"]');
    this.radioButtons.forEach((radioButton) => {
      radioButton.addEventListener("change", (e: Event) => {
        const target = e.target as HTMLInputElement;
        console.log(target.id, target.checked);
        //selezionato il radio button con fornitura
        if (target.checked && target.id == "has-coverage-true") {
          //selezionato il radio button con fornitura

          document
            .querySelector("#resume-has-coverage")
            .classList.add("opened");
          document
            .querySelector("#resume-has-coverage")
            .classList.remove("closed");
          document
            .querySelector("#resume-hasnot-coverage")
            .classList.remove("opened");
          document
            .querySelector("#resume-hasnot-coverage")
            .classList.add("closed");
          document
            .querySelector("#product-total-accordion-main")
            .classList.add("d-none");
          document
            .querySelector("#product-total-accordion-variant")
            .classList.remove("d-none");

          //sticky button mobile
          document.querySelector<HTMLAnchorElement>("#sticky-buy-button").href =
            new URL(pricings[0]?._links[0]?.href)?.toString();

          // marketing campaign
          if (sessionStorage.getItem("cmp")) {
            let pInfoEncoded: string = new URLSearchParams(
              new URL(pricings[0]._links[0].href).search
            ).get("pinfo");
            let pInfoDecoded = JSON.parse(
              decodeURIComponent(escape(window.atob(pInfoEncoded)))
            );
            pInfoDecoded.cmp = sessionStorage.getItem("cmp");

            pInfoEncoded = window.btoa(
              unescape(encodeURIComponent(JSON.stringify(pInfoDecoded)))
            );

            let searchParams = new URLSearchParams(
              new URL(pricings[0]._links[0].href).search
            );
            searchParams.set("pinfo", pInfoEncoded);
            //searchParams.toString();
            let newUrl: URL = new URL(pricings[0]._links[0].href);
            newUrl.search = searchParams.toString();

            document.querySelector<HTMLAnchorElement>(
              "#sticky-buy-button"
            ).href = newUrl.href.toString();
          }

          //se si tratta di installazione non metto il prezzo
          if (this.supplyMacrocategoria != "installazione") {
            document.querySelector<HTMLSpanElement>(
              "#sticky-product-total"
            ).innerText =
              "€ " + Utils.floatToEuro(Number(pricings[0]?.prezzoTotale));
          } else {
            document.querySelector<HTMLSpanElement>(
              "#sticky-product-total"
            ).innerText = __("Da definire", "unipolhome");
          }
        } //selezionato il radio button senza fornitura
        else if (target.checked == true && target.id == "has-coverage-false") {
          document
            .querySelector("#resume-hasnot-coverage")
            .classList.add("opened");
          document
            .querySelector("#resume-hasnot-coverage")
            .classList.remove("closed");
          document
            .querySelector("#product-total-accordion-main")
            .classList.remove("d-none");
          document
            .querySelector("#product-total-accordion-variant")
            .classList.add("d-none");
          document
            .querySelector("#resume-has-coverage")
            .classList.remove("opened");
          document
            .querySelector("#resume-has-coverage")
            .classList.add("closed");
          //sticky button mobile
          document.querySelector<HTMLAnchorElement>("#sticky-buy-button").href =
            new URL(pricings[1]?._links[0]?.href)?.toString();

          // marketing campaign
          if (sessionStorage.getItem("cmp")) {
            let pInfoEncoded: string = new URLSearchParams(
              new URL(pricings[1]._links[0].href).search
            ).get("pinfo");
            let pInfoDecoded = JSON.parse(
              decodeURIComponent(escape(window.atob(pInfoEncoded)))
            );
            pInfoDecoded.cmp = sessionStorage.getItem("cmp");

            pInfoEncoded = window.btoa(
              unescape(encodeURIComponent(JSON.stringify(pInfoDecoded)))
            );

            let searchParams = new URLSearchParams(
              new URL(pricings[1]._links[0].href).search
            );
            searchParams.set("pinfo", pInfoEncoded);
            //searchParams.toString();
            let newUrl: URL = new URL(pricings[1]._links[0].href);
            newUrl.search = searchParams.toString();

            document.querySelector<HTMLAnchorElement>(
              "#sticky-buy-button"
            ).href = newUrl.href.toString();
          }

          //se si tratta di installazione non metto il prezzo
          if (this.nosupplyMacrocategoria != "installazione") {
            document.querySelector<HTMLSpanElement>(
              "#sticky-product-total"
            ).innerText =
              "€ " + Utils.floatToEuro(Number(pricings[1]?.prezzoTotale));
          } else {
            document.querySelector<HTMLSpanElement>(
              "#sticky-product-total"
            ).innerText = __("Da definire", "unipolhome");
          }
        }
      });
    });
  };

  /**
   * Gestisce logica di caricamento step in caso di CAP da querystring
   */
  async handleQueryStringCAP() {
    if (this.spinner) {
      this.spinner.style.display = "block";
    }

    this.coverageFormContainer.style.display = "none";
    this.handleCoverageButtonClick(
      this.cap,
      this.supplyID,
      this.nosupplyID,
      true
    );
  }

  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  /**
   * Invia al servizio di BE la richiesta per la verifica della copertura del servizio
   * @param cap CAP
   * @param mainProductID ID prodotto
   * @param variantID ID variant
   * @param noClickTracking disabilita tracking click (es. cap da url)
   */

  async handleCoverageButtonClick(
    cap: string,
    mainProductID: string,
    variantID?: string,
    noClickTracking: boolean = false
  ) {
    console.info("Checking coverage...");
    Utils.toggleSubmitButtonStatus(this.sendButton, "loading");

    const ProductChecks = [];
    if (this.supplyID) {
      ProductChecks.push(ProductApi.checkProductCoverage(cap, mainProductID));
    }
    console.log(ProductChecks);
    if (variantID) {
      ProductChecks.push(ProductApi.checkProductCoverage(cap, variantID));
    }

    Promise.all(ProductChecks)
      .then((data) => {
        console.log("product checks", data);
        if (!data || data?.filter((element) => !!element).length == 0) {
          this.handleError();
        } else {
          if ("URLSearchParams" in window && cap) {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("cap", cap);
            var newRelativePathQuery =
              window.location.pathname +
              "?" +
              searchParams.toString() +
              window.location.hash;
            history.replaceState(null, "", newRelativePathQuery);
          }
          if (!noClickTracking) this.trackings.trackProductCapCheckClick();

          this.prepareFinalStep(
            data.find((res) => res?.id == mainProductID), //== variantID
            data.find((res) => res?.id == variantID)
          );
        }
      })
      .catch((e) => {
        console.error("error", e);
        this.handleError();
        Utils.toggleSubmitButtonStatus(this.sendButton, "enabled");
      });
  }

  private async renderProductNotConfigured() {
    await ProductRenderers.renderProductNotConfigured(this.mainContainer);
  }
}

export default new CoverageCheck();
